<template>
  <div class="Jiaodui">
    <div class="container">
      <h2>Thesis Proofreading Service</h2>
      <p>Academic papers pay great attention to logical thinking, requiring clear and reasonable logical relations between sentences, paragraphs and chapters, and the whole article should also have a very obvious logical thinking, so as to effectively express the academic thought we want to express. In addition, the details of vocabulary, grammar and literature citation will also affect whether the paper can get high marks. In order to help you write high-quality papers, students can teach you how to write a high-score Chinese paper from word syntax, logical thinking and article structure.</p>
      <div class="imgbox">
        <img src="@/assets/jiaodui001.png"
             alt="">
      </div>
      <p>Proofreaders' proofreading services provide more than basic checks of spelling, grammar and punctuation. We are experienced in providing proofreading services for international students whose mother tongue is not Chinese.</p>
      <p>Our proofreading team understands the students' views and will proofread your articles or papers to ensure their academic reading and help you avoid losing points because your Chinese is not perfect. Our proofreaders will also provide comments. For example, they may emphasize areas that need to be improved, such as clearer.</p>
      <p><b>In summary, our proofreading services provide:</b></p>
      <p>· correct grammatical errors</p>
      <p>· correction of punctuation errors</p>
      <p>· correct spelling mistakes</p>
      <p>· correction of printing errors</p>
      <p>Style change – for example, replace basic words with more formal alternatives where appropriate</p>
      <p>For example, when a sentence is not clear enough, the comment box will indicate.</p>
      <p><b>Proofreading service scheme</b></p>
      <div class="shenqingTit">Our advantages</div>
      <p>
        Different service schemes meet your various needs
      </p>
    </div>
    <div class="_cont">
      <div>
        <van-tabs border
                  animated
                  title-active-color="#263e65">
          <van-tab title="Good Quality">
            <div class="container">
              <div class="_lis">
                <div class="imgbox">
                  <img src="@/assets/A001.png"
                       alt="">
                </div>
                <van-row>
                  <van-col span="12">
                    <div class="_btn"
                         @click="onShowDetail('0')">Plan and time selection</div>
                  </van-col>
                  <van-col span="12">
                    <div class="_btn"
                         @click="onShowForm('Good Quality')">Choose the scheme</div>
                  </van-col>
                </van-row>

              </div>
            </div>
          </van-tab>
          <van-tab title="Whole Process">
            <div class="container">

              <div class="_lis">
                <div class="imgbox">
                  <img src="@/assets/A001.png"
                       alt="">
                </div>
                <van-row>
                  <van-col span="12">
                    <div class="_btn"
                         @click="onShowDetail('1')">Plan and time selection</div>
                  </van-col>
                  <van-col span="12">

                    <div class="_btn"
                         @click="onShowForm('Whole Process')">Choose the scheme</div>
                  </van-col>
                </van-row>
              </div>
            </div>
          </van-tab>
          <van-tab title="Scientific Process">
            <div class="container">

              <div class="_lis">
                <div class="imgbox">
                  <img src="@/assets/A001.png"
                       alt="">
                </div>
                <van-row>
                  <van-col span="12">
                    <div class="_btn"
                         @click="onShowDetail('2')">Plan and time selection</div>
                  </van-col>
                  <van-col span="12">
                    <div class="_btn"
                         @click="onShowForm('Scientific Process')">Choose the scheme</div>
                  </van-col>
                </van-row>
              </div>
            </div>

          </van-tab>
        </van-tabs>
      </div>

    </div>
    <div class="container">

      <p><b>Information confidentiality</b></p>
      <p>An exclusive contract has been signed. Only the editor in charge of your file has permission to see the contents of the file.</p>
      <p><b>Reliable quality</b></p>
      <p>Excellent professional team to ensure high-quality service output, multi round interaction to ensure that the service runs on demand.</p>
      <p><b>Privacy protection</b></p>
      <p>By signing a confidentiality agreement, your personal information will be strictly protected and will not be disclosed to third parties.</p>
      <p><b>Punctual service</b></p>
      <p>Submit the manuscript in strict accordance with the date and time determined during work confirmation.</p>
      <p><b>Real time communication</b></p>
      <p>Real time communication progress, timely feedback, perfect service to every customer.</p>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="formCont">
        <div class="head">
          {{formTit}}
        </div>
        <van-form @submit="onSubmit"
                  ref="formName">
          <van-field v-model="form1.name"
                     name="姓名"
                     label="姓名"
                     placeholder="姓名"
                     :rules="[{ required: true, message: '请填写姓名' }]" />
          <van-field v-model="form1.phone"
                     name="电话"
                     label="电话"
                     placeholder="电话"
                     :rules="[{ required: true, message: '请填写电话' }]" />
          <van-field v-model="form1.email"
                     name="邮箱"
                     label="邮箱"
                     placeholder="邮箱"
                     :rules="[{ required: true, message: '请填写邮箱' }]" />

          <p class="beizhu">Note: Please leave your message, our consultant will contact you soon ASAP. <br>
            * Working Hours (Beijing time 9:00am-5:30pm Monday-Friday, except national holidays)</p>
          <div style="margin: 16px;">
            <van-button round
                        block
                        type="info"
                        native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="showDetail"
               position="bottom"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="detailCont">
        <div class="list"
             v-if="detailType == 0">
          <div class="head">Good Quality</div>
          <van-collapse v-model="activeNames"
                        class="listBox">
            <van-collapse-item title="1-1500 words"
                               name="1">
              <div class="list-cont">
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥0.60/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥0.90/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="1501-4000 words"
                               name="2">
              <div class="list-cont">
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥0.60/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥0.70/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥0.90/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="4001-7000 words"
                               name="3">
              <div class="list-cont">
                <p><b>4 working days :</b></p>
                <p class="pre">
                  <span>¥0.60/word</span>
                </p>
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥0.70/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥0.80/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥1.00/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="7001-10000 words"
                               name="4">
              <div class="list-cont">
                <p><b>6 working days :</b></p>
                <p class="pre">
                  <span>¥0.48/word</span>
                </p>
                <p><b>4 working days :</b></p>
                <p class="pre">
                  <span>¥0.56/word</span>
                </p>
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥0.64/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥0.72/word</span>
                </p>

              </div>
            </van-collapse-item>
            <van-collapse-item title="≧10000 words"
                               name="5">
              <div class="list-cont">
                <p><b>6 working days</b></p>
                <p class="pre">
                  <span>¥0.45/word</span>
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div class="list"
             v-if="detailType == 1">
          <div class="head">Whole Process</div>
          <van-collapse v-model="activeNames"
                        class="listBox">
            <van-collapse-item title="1-1500 words"
                               name="1">
              <div class="list-cont">
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.20/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥1.80/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="1501-4000 words"
                               name="2">
              <div class="list-cont">
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥1.20/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.40/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥1.80/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="4001-7000 words"
                               name="3">
              <div class="list-cont">
                <p><b>4 working days :</b></p>
                <p class="pre">
                  <span>¥1.20/word</span>
                </p>
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥1.40/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.60/word</span>
                </p>
                <p><b>隔日返稿（24h）/ 当天20：30钱提交订单 :</b></p>
                <p class="pre">
                  <span>¥2.00/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="7001-10000 words"
                               name="4">
              <div class="list-cont">
                <p><b>6 working days :</b></p>
                <p class="pre">
                  <span>¥0.96/word</span>
                </p>
                <p><b>4 working days :</b></p>
                <p class="pre">
                  <span>¥1.12/word</span>
                </p>
                <p><b>3 working days :</b></p>
                <p class="pre">
                  <span>¥1.28/word</span>
                </p>
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.44/word</span>
                </p>

              </div>
            </van-collapse-item>
            <van-collapse-item title="≧10000 words"
                               name="5">
              <div class="list-cont">
                <p><b>6 working days</b></p>
                <p class="pre">
                  <span>¥0.90/word</span>
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div class="list"
             v-if="detailType == 2">
          <div class="head">Scientific Process</div>
          <van-collapse v-model="activeNames"
                        class="listBox">
            <van-collapse-item title="1-1500 words"
                               name="1">
              <div class="list-cont">
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.62/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="1501-4000 words"
                               name="2">
              <div class="list-cont">
                <p><b>2 working days :</b></p>
                <p class="pre">
                  <span>¥1.53/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="4001-7000 words"
                               name="3">
              <div class="list-cont">
                <p><b>4 working days :</b></p>
                <p class="pre">
                  <span>¥1.44/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="7001-10000 words"
                               name="4">
              <div class="list-cont">
                <p><b>6 working days :</b></p>
                <p class="pre">
                  <span>¥1.35/word</span>
                </p>
              </div>
            </van-collapse-item>
            <van-collapse-item title="≧10000 words"
                               name="5">
              <div class="list-cont">
                <p><b>6 working days</b></p>
                <p class="pre">
                  <span>¥1.26/word</span>
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div class="container">
          <p>*Holidays and weekends, five working days a week.</p>
          <p>*There may be time difference at home and abroad, mainly Beijing time.</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import axiosApi from "../api/api.js";
import { Toast } from 'vant';
export default {
  name: 'Jieji',
  components: {
  },
  data () {
    return {
      activeNames: [''],
      showForm: false,
      showDetail: false,
      detailType: 0,
      formTit: '',
      form1: {
        name: '',
        phone: '',
        email: '',
      },
    }
  },
  methods: {
    onSubmit () {
      axiosApi('message', {
        form_type: 4,
        content: this.formTit,
        ...this.form1
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('Success');
          this.showForm = false
          this.form1 = {
            name: '',
            phone: '',
            email: '',
          }
        } else {
          Toast.fail('Error, please try again');
        }
      })
    },
    onShowForm (val) {
      this.formTit = val
      this.showForm = true
    },
    onShowDetail (val) {
      this.detailType = val
      this.showDetail = true
    },
    clearForm () {
      this.$refs.formName.resetValidation();
      this.form1 = {
        name: '',
        phone: '',
        email: '',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Jiaodui {
  height: 100%;
  overflow: auto;
}
.container {
  padding-bottom: 0;
  h2 {
    text-align: center;
  }
  h4 {
    margin: 0;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    // text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}

._cont {
  .head {
    background-color: #263e65;
    color: #fff;
    text-align: center;
    padding: 20px 0;
  }
  ._lis {
    padding: 20px;
    margin-bottom: 40px;
    background-color: #f7f8fa;
    border-radius: 15px;
    margin-top: 20px;
    h3 {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  ._btn {
    background-color: #f6cb47;
    color: #fff;
    border-radius: 10px;
    padding: 20px 0;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    width: 95%;
  }
}
.formCont {
  padding-top: 20px;
  padding-bottom: 60px;
  .head {
    text-align: center;
    font-size: 36px;
    margin-bottom: 20px;
  }
  .beizhu {
    padding: 20px;
  }
}
.detailCont {
  padding: 20px 0;
  .head {
    text-align: center;
    font-size: 36px;
    margin-bottom: 20px;
  }
  .listBox {
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    .list-cont {
      color: #545454;
      .pre {
        color: red;
        margin-bottom: 20px;
      }
    }
  }
  .container {
    padding: 20px;
    color: #545454;
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
